import gql from 'graphql-tag';

const FRGMENTS = gql`
  fragment CalendarAccount on calendar_accounts {
    id
    user_id
    calendar_id
    connected_account_id
    created_at
    provider
    email
    active
    buffer_before
    buffer_after  
  }
`;

export const GET_ACCOUNT = gql`
  query getAccount($userId: Int!) {
    accounts: calendar_accounts(where: { active: { _neq: false }, user_id: {_eq: $userId } }) {
      ...CalendarAccount
    }
  }
  ${FRGMENTS}
`;

export const GET_ACCOUNT_BY_SUB = gql`
    query getAccountBySub($sub: String) {
        accounts: calendar_accounts(where: { connected_account_id: {_eq: $sub} }) {
            ...CalendarAccount
        }
    }
    ${FRGMENTS}
`;

export const GET_ELEMENT_TOKEN = gql`
  query getToken {
    calendar_accounts_token {
      token
    }
  }
`;

export const ADD_CALENDAR = gql`
  mutation addCal($code: String!) {
    connect_calendar(input: { code: $code }) {
      id
      calendar_id
      connected_account_id
      user_id
    }
  }
`;

export const GET_AVAILABILITY_TOKEN = gql`
  query getToken($userIds: [Int!]!, $studentId: Int!) {
    availability_token(input: { user_ids: $userIds, student_id: $studentId }) {
      token
    }
  }
`;

export const DELETE_CALENDAR = gql`
  mutation deleteAccount($id: Int!) {
    delete_calendar_accounts_by_pk(id: $id) {
      id
    }
  }
`;

export const UPDATE_CALENDAR_ACCOUNT = gql`
  mutation updateAccount($id: Int!, $data: calendar_accounts_set_input) {
    update_calendar_accounts_by_pk(pk_columns: { id: $id }, _set: $data) {
      ...CalendarAccount
    }
  }
  ${FRGMENTS}
`;
